<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          headline="Edit Content Block"
          :initial="contentBlock.attributes"
          :errors="errors"
          :edit="true"
          :block-drivers="blockDrivers.filter(blockDriver => blockDriver.attributes.layout_categories.includes(contentLayout.attributes.layout_category))"
          :content-row="contentRow"
          :portal="portal"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from "../../../../../../../../components/Administration/ContentBlocks/Panels/Form";
import LoadingContainer from '../../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {FormPanel, LoadingContainer},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentLayout: null,
      contentRow: null,
      contentBlock: null,

      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/content-layouts/' + this.$route.params.contentLayoutId),
        http.get('/api/v2/content-layouts/' + this.$route.params.contentLayoutId + '/content-rows/' + this.$route.params.contentRowId),
        http.get('/api/v2/content-blocks/' + this.$route.params.contentBlockId),
      ])
          .then(responses => {
            this.contentLayout = responses[0].data.data

            this.contentRow = responses[1].data.data

            this.contentBlock = responses[2].data.data

            this.loading = false
          })
    },

    submit(data) {
      http.put('/api/v2/content-blocks/' + this.$route.params.contentBlockId, data)
          .then(() => {
            notify.success('The content block was saved')

            this.$router.push('../../../../edit')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
